<script>
    import {fade} from 'svelte/transition';
    import {navigateTo} from 'svelte-router-spa';
    import {PRConnect} from "@projectroom/ui-lib";
	import { _ } from 'svelte-i18n';
	import { Card, Button, Dialog } from '../lib/ui';

    let email;
    let emailRef;
    let emailBorder = false;
    let validMessage = false;
    let popupSuccess = false;
    let errorMesage;

    // shadcn 인풋 공용 클래스
    const inputCls = "tw-flex tw-h-11 tw-w-full tw-rounded-md tw-border tw-border-input tw-bg-background tw-px-3 tw-py-2 tw-text-sm tw-text-foreground placeholder:tw-text-muted-foreground focus:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-ring disabled:tw-opacity-50";
    const errStyle = "border-color:hsl(var(--sb-destructive))";

    const validEmail = () => {
        const regex = /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/i;
        return email.match(regex) == null;
    }

    const changeEmail = () => {
        errorMesage = undefined;
        emailBorder = validEmail();
    }

    const clickEmailSubmit = () => {
        if (validEmail()) {
            emailRef.focus();
            errorMesage = $_('project.common.1_1');
            return;
        }
        PRConnect.send("/api/Aws/sendEmail", {emailId : email}, data => {
            if (data.result.status === "error") {
                errorMesage = data.result.message;
            } else {
                popupSuccess = true;
            }
        });
    }

</script>

<div class="tw-flex tw-min-h-screen tw-justify-center tw-bg-background tw-px-4 tw-pb-20 tw-pt-24 tw-font-sans tw-text-foreground sm:tw-pt-28" in:fade>
    <div class="tw-w-full tw-max-w-[420px]">
        <Card class="tw-p-8 sm:tw-p-10">
            <h1 class="tw-mb-1 tw-text-center tw-text-2xl tw-font-bold tw-text-foreground">{$_('project.common.1')}</h1>
            <p class="tw-mt-2 tw-text-center tw-text-sm tw-text-muted-foreground">{$_('project.common.1_3')}</p>

            {#if errorMesage}
                <div class="tw-mt-4 tw-rounded-md tw-bg-destructive/10 tw-px-3 tw-py-2 tw-text-center tw-text-sm tw-font-medium tw-text-destructive">{errorMesage}</div>
            {/if}

            <form class="tw-mt-6 tw-space-y-4" on:submit|preventDefault={clickEmailSubmit}>
                <div>
                    <label for="findpw-email" class="tw-mb-1.5 tw-block tw-text-sm tw-font-medium tw-text-foreground">{$_('project.common.2')}</label>
                    <input id="findpw-email" type="email" maxlength="256" placeholder={$_('project.common.3')} bind:value={email} bind:this={emailRef} on:change={changeEmail} class={inputCls} style={emailBorder ? errStyle : ""} />
                </div>

                <Button type="submit" size="lg" class="tw-w-full">{$_('project.common.4')}</Button>
            </form>

            <p class="tw-mt-6 tw-text-center tw-text-sm tw-text-muted-foreground">
                <button type="button" class="tw-cursor-pointer tw-bg-transparent tw-font-semibold tw-text-primary hover:tw-underline" on:click={()=>navigateTo("/login")}>{$_('project.common.5')}</button>{$_('project.common.5_1')}
            </p>
        </Card>
    </div>
</div>

<Dialog open={popupSuccess} title={$_('project.common.5_2')} on:close={()=> popupSuccess = false}>
    <p class="tw-m-0 tw-text-sm tw-text-muted-foreground">{$_('project.common.1_3')}</p>
    <Button slot="footer" on:click={()=> popupSuccess = false}>{$_('project.common.5_3')}</Button>
</Dialog>
